import type { ReactNode } from 'react';
import { Sidebar, type SidebarSection } from './Sidebar.js';
import { TopBar } from './TopBar.js';

interface AppShellProps {
  title: string;
  /** V2.1-H — subtitle under the brand title in the sidebar header. */
  subtitle?: string;
  /** V2.1-H — optional custom brand icon (defaults to primary-tinted mark). */
  brandIcon?: ReactNode;
  sections: SidebarSection[];
  userEmail?: string;
  onSignOut?: () => void;
  /**
   * Wave 7 (PR #20) — sidebar footer, passed straight through to the
   * underlying Sidebar primitive. Lets admin app render the current
   * user (avatar + name) in the footer slot, mirroring the main app.
   */
  sidebarFooter?: ReactNode;
  children: ReactNode;
}

export function AppShell({
  title,
  subtitle,
  brandIcon,
  sections,
  userEmail,
  onSignOut,
  sidebarFooter,
  children,
}: AppShellProps) {
  return (
    <div className="flex h-screen bg-paper-1">
      <Sidebar
        title={title}
        subtitle={subtitle}
        brandIcon={brandIcon}
        sections={sections}
        footer={sidebarFooter}
      />
      <div className="flex flex-1 flex-col overflow-hidden bg-paper-0">
        <TopBar userEmail={userEmail} onSignOut={onSignOut} />
        <main className="flex-1 overflow-auto px-6 py-6">{children}</main>
      </div>
    </div>
  );
}
